import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
import {
  getCurriculumsV2,
  getCurriculumsV2WithGrades,
  getGradesV2,
} from './api';
import { RootState } from '../..';

export interface IGradeV2 {
  grade: string;
}

export interface ISubjectV2 {
  subject: string;
  grade: Array<IGradeV2>;
}

export interface ICurriculumV2 {
  curriculum: string;
  subjects: Array<ISubjectV2>;
}

export interface ICurriculumWithGrade {
  name: string;
  grades: Array<{ grade: string }>;
}

export interface ICurriculumV2State {
  status: 'idle' | 'loading' | 'rejected';
  list: ICurriculumV2[];
  curriculumsWithGradesList: ICurriculumWithGrade[];
  gradeList: IGradeV2[];
}

const initialState: ICurriculumV2State = {
  status: 'idle',
  list: [],
  curriculumsWithGradesList: [],
  gradeList: [],
};

export const CurriculumSlice = createSlice({
  name: 'curriculumV2',
  initialState,
  reducers: {
    resetCurriculumsWithGradesList: (state) => {
      state.curriculumsWithGradesList = [];
    },
    resetGradeList: (state) => {
      state.gradeList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurriculumsV2.fulfilled, (state, action) => {
        state.list = action.payload;
      })
      .addCase(getCurriculumsV2WithGrades.fulfilled, (state, action) => {
        state.curriculumsWithGradesList = action.payload;
      })
      .addCase(getGradesV2.fulfilled, (state, action) => {
        state.gradeList = action.payload;
      });

    // Matchers
    builder
      .addMatcher(
        isPending(getCurriculumsV2, getCurriculumsV2WithGrades),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        isRejected(getCurriculumsV2, getCurriculumsV2WithGrades),
        (state) => {
          state.status = 'rejected';
        }
      )
      .addMatcher(
        isFulfilled(getCurriculumsV2, getCurriculumsV2WithGrades),
        (state) => {
          state.status = 'idle';
        }
      );
  },
});

export const getCurriculumV2State = (
  state: RootState
): RootState['curriculumV2'] => state.curriculumV2;

export const {
  resetCurriculumsWithGradesList,
  resetGradeList,
} = CurriculumSlice.actions;

export * from './api';
export default CurriculumSlice.reducer;
